module.exports = __webpack_public_path__ + "img/设备号.aa4e3d1b.svg";